import type { SVGProps } from 'react';
const SvgPaperPlane = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M23.656 1.244a.998.998 0 0 0-1.069-.156l-22 10a1 1 0 0 0 .138 1.875L7 14.754v7.247a.998.998 0 0 0 1.831.553l3.513-5.262 5.209 2.606c.266.131.575.141.847.022s.478-.35.559-.634l5-17a1.01 1.01 0 0 0-.303-1.041zM3.888 11.784l14.078-6.4-9.603 7.684a1.007 1.007 0 0 0-.087-.031l-4.387-1.253zM9 18.697V14c0-.05-.003-.1-.012-.15L19.46 5.472l-8.228 9.888a1.531 1.531 0 0 0-.063.084L9 18.697zm8.378-1.125-4.722-2.362 8.375-10.066-3.653 12.428z" />
  </svg>
);
export default SvgPaperPlane;
